import { slideDown, slideUp } from './slideToggle';

const basis = document.querySelectorAll('.js-toggle-form');

if (basis) {
  basis.forEach((base) => {
    base.addEventListener('change', () => {
      ToggleForm(base as HTMLElement);
    });

    window.addEventListener('load', () => {
      if ((base as HTMLInputElement)&&(base as HTMLInputElement).checked) {
        ToggleForm(base as HTMLElement);
      }
    });
  });
}

const ToggleForm = async(base: HTMLElement) => {
  await CloseToggle();
  const target = document.querySelector<HTMLElement>(
    `${(base as HTMLElement).dataset.target}`
  );
  if (target) {
    setTimeout(()=>{
      target.classList.add("slide-toggle-open");
      slideDown(target);
    }, 300);
  }
};

const CloseToggle = ():Promise<boolean> => {
  return new Promise((resolve) => {
    setTimeout(()=>{
      const targets = document.querySelector(".slide-toggle-open") as HTMLElement;
      if (targets) {
        slideUp(targets);
        targets.classList.remove("slide-toggle-open");
      }
      resolve(true);
    }, 100);
  })
}
